import { useMedia } from 'react-use'

import { BREAKPOINT_DIMENSIONS } from '@/lib/constants'
import { Breakpoint } from '@/types/misc'

// See https://tailwindcss.com/docs/responsive-design#overview
function useMaxWidth(breakpoint: Breakpoint) {
  const breakpointDimensions: Record<Breakpoint, number> = {
    sm: BREAKPOINT_DIMENSIONS.sm - 1,
    md: BREAKPOINT_DIMENSIONS.md - 1,
    lg: BREAKPOINT_DIMENSIONS.lg - 1,
    xl: BREAKPOINT_DIMENSIONS.xl - 1,
    '2xl': BREAKPOINT_DIMENSIONS['2xl'] - 1,
  }

  return useMedia(`(max-width: ${breakpointDimensions[breakpoint]}px)`)
}

export default useMaxWidth
